import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0,524.663558 L878.039001,1337.09375 L1470.49316,779.857699 C1519.09634,804.87243 1572.41721,820.342067 1628.70036,822.865483 C1634.51519,823.08491 1640.11059,823.194624 1645.92541,823.194624 C1684.21551,823.194624 1720.53075,816.063231 1755.41972,805.640427 L1755.41972,805.640427 L1755.41972,1663.27267 L1330.60815,1171.42601 L1247.66457,1243.06908 L1690.46919,1755.76135 L64.9505296,1755.76135 L507.755154,1243.06908 L424.811572,1171.42601 L0,1663.27267 L0,524.663558 Z M1278.97686,329.559627 C1270.19977,359.182335 1263.50723,389.792466 1262.19066,422.158018 C1257.58269,524.630644 1293.12994,622.71472 1362.46902,698.417196 C1367.84499,704.341737 1374.3181,708.730287 1380.02321,714.215973 L1380.02321,714.215973 L877.424604,1187.08216 L0.043885493,375.090826 L0.043885493,329.559627 Z M1645.55239,165 C1649.6118,165 1653.78092,165.109714 1657.95004,165.219427 C1809.24528,172.021679 1926.41954,300.057605 1919.72701,451.462555 C1913.14418,598.588671 1791.80079,713.568662 1645.99124,713.568662 C1641.93183,713.568662 1637.653,713.458949 1633.48388,713.239521 C1482.18864,706.546983 1365.01437,578.401344 1371.81663,426.996393 C1378.28974,279.870278 1499.74284,165 1645.55239,165 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNextUnreadSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconNextUnreadSolid, _Component);

  var _super = _createSuper(IconNextUnreadSolid);

  function IconNextUnreadSolid() {
    _classCallCheck(this, IconNextUnreadSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconNextUnreadSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNextUnread",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconNextUnreadSolid.displayName = "IconNextUnreadSolid";
  return IconNextUnreadSolid;
}(Component);

IconNextUnreadSolid.glyphName = 'next-unread';
IconNextUnreadSolid.variant = 'Solid';
IconNextUnreadSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNextUnreadSolid;
export { IconNextUnreadSolid };